/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface MessagingService {
  /**
   * @summary Create Conversation
   * @description Create a new conversation.
   */
  createConversationMessagingConversationsPost: {
    /**
     * @summary Create Conversation
     * @description Create a new conversation.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateConversationMessagingConversationsPostBody,
        CreateConversationMessagingConversationsPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateConversationMessagingConversationsPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateConversationMessagingConversationsPostBody,
          CreateConversationMessagingConversationsPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CreateConversationMessagingConversationsPostData,
          CreateConversationMessagingConversationsPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        CreateConversationMessagingConversationsPostData,
        CreateConversationMessagingConversationsPostError
      >
    >;
    /**
     * @summary Create Conversation
     * @description Create a new conversation.
     */
    getMutationKey(
      parameters: DeepReadonly<CreateConversationMessagingConversationsPostParameters> | void
    ): ServiceOperationMutationKey<
      CreateConversationMessagingConversationsPostSchema,
      CreateConversationMessagingConversationsPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Conversation
     * @description Create a new conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.createConversationMessagingConversationsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.createConversationMessagingConversationsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateConversationMessagingConversationsPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateConversationMessagingConversationsPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateConversationMessagingConversationsPostSchema,
        CreateConversationMessagingConversationsPostData,
        CreateConversationMessagingConversationsPostParameters,
        TVariables,
        OperationError<CreateConversationMessagingConversationsPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateConversationMessagingConversationsPostData,
      OperationError<CreateConversationMessagingConversationsPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Conversation
     * @description Create a new conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.createConversationMessagingConversationsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.createConversationMessagingConversationsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateConversationMessagingConversationsPostBody,
        CreateConversationMessagingConversationsPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateConversationMessagingConversationsPostSchema,
        CreateConversationMessagingConversationsPostData,
        CreateConversationMessagingConversationsPostParameters,
        TVariables,
        OperationError<CreateConversationMessagingConversationsPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateConversationMessagingConversationsPostData,
      OperationError<CreateConversationMessagingConversationsPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create Conversation
     * @description Create a new conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createConversationMessagingConversationsPostTotal = qraft.messagingService.createConversationMessagingConversationsPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createConversationMessagingConversationsPostTotal = qraft.messagingService.createConversationMessagingConversationsPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateConversationMessagingConversationsPostBody,
            CreateConversationMessagingConversationsPostData,
            CreateConversationMessagingConversationsPostParameters,
            OperationError<CreateConversationMessagingConversationsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateConversationMessagingConversationsPostSchema,
            CreateConversationMessagingConversationsPostBody,
            CreateConversationMessagingConversationsPostData,
            CreateConversationMessagingConversationsPostParameters,
            OperationError<CreateConversationMessagingConversationsPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create Conversation
     * @description Create a new conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createConversationMessagingConversationsPostPendingMutationVariables = qraft.messagingService.createConversationMessagingConversationsPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createConversationMessagingConversationsPostMutationData = qraft.messagingService.createConversationMessagingConversationsPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateConversationMessagingConversationsPostData,
        OperationError<CreateConversationMessagingConversationsPostError>,
        MutationVariables<
          CreateConversationMessagingConversationsPostBody,
          CreateConversationMessagingConversationsPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateConversationMessagingConversationsPostBody,
            CreateConversationMessagingConversationsPostData,
            CreateConversationMessagingConversationsPostParameters,
            OperationError<CreateConversationMessagingConversationsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateConversationMessagingConversationsPostSchema,
            CreateConversationMessagingConversationsPostBody,
            CreateConversationMessagingConversationsPostData,
            CreateConversationMessagingConversationsPostParameters,
            OperationError<CreateConversationMessagingConversationsPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateConversationMessagingConversationsPostData,
          OperationError<CreateConversationMessagingConversationsPostError>,
          MutationVariables<
            CreateConversationMessagingConversationsPostBody,
            CreateConversationMessagingConversationsPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Create Conversation
     * @description Create a new conversation.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateConversationMessagingConversationsPostBody,
            CreateConversationMessagingConversationsPostData,
            CreateConversationMessagingConversationsPostParameters,
            OperationError<CreateConversationMessagingConversationsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateConversationMessagingConversationsPostSchema,
            CreateConversationMessagingConversationsPostBody,
            CreateConversationMessagingConversationsPostData,
            CreateConversationMessagingConversationsPostParameters,
            OperationError<CreateConversationMessagingConversationsPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create Conversation
     * @description Create a new conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.messagingService.createConversationMessagingConversationsPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.messagingService.createConversationMessagingConversationsPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateConversationMessagingConversationsPostBody,
              CreateConversationMessagingConversationsPostData,
              CreateConversationMessagingConversationsPostParameters,
              OperationError<CreateConversationMessagingConversationsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateConversationMessagingConversationsPostSchema,
              CreateConversationMessagingConversationsPostBody,
              CreateConversationMessagingConversationsPostData,
              CreateConversationMessagingConversationsPostParameters,
              OperationError<CreateConversationMessagingConversationsPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateConversationMessagingConversationsPostData,
            CreateConversationMessagingConversationsPostError,
            MutationVariables<
              CreateConversationMessagingConversationsPostBody,
              CreateConversationMessagingConversationsPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateConversationMessagingConversationsPostBody,
              CreateConversationMessagingConversationsPostData,
              CreateConversationMessagingConversationsPostParameters,
              OperationError<CreateConversationMessagingConversationsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateConversationMessagingConversationsPostSchema,
              CreateConversationMessagingConversationsPostBody,
              CreateConversationMessagingConversationsPostData,
              CreateConversationMessagingConversationsPostParameters,
              OperationError<CreateConversationMessagingConversationsPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateConversationMessagingConversationsPostData,
          CreateConversationMessagingConversationsPostError,
          MutationVariables<
            CreateConversationMessagingConversationsPostBody,
            CreateConversationMessagingConversationsPostParameters
          >,
          TContext
        >
      >;
    };
    schema: CreateConversationMessagingConversationsPostSchema;
    types: {
      parameters: CreateConversationMessagingConversationsPostParameters;
      data: CreateConversationMessagingConversationsPostData;
      error: CreateConversationMessagingConversationsPostError;
      body: CreateConversationMessagingConversationsPostBody;
    };
  };
  /**
   * @summary List Conversations
   * @description List conversations with optional filters.
   */
  listConversationsMessagingConversationsGet: {
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<ListConversationsMessagingConversationsGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListConversationsMessagingConversationsGetSchema,
        options: {
          parameters: ListConversationsMessagingConversationsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetError
        >
      >
    ): Promise<
      RequestFnResponse<ListConversationsMessagingConversationsGetData, ListConversationsMessagingConversationsGetError>
    >;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    getQueryKey(
      parameters: DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void
    ): ServiceOperationQueryKey<
      ListConversationsMessagingConversationsGetSchema,
      ListConversationsMessagingConversationsGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Conversations
     * @description List conversations with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.messagingService.listConversationsMessagingConversationsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.messagingService.listConversationsMessagingConversationsGet.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = ListConversationsMessagingConversationsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetError,
          TData,
          ServiceOperationQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListConversationsMessagingConversationsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Conversations
     * @description List conversations with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.messagingService.listConversationsMessagingConversationsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.messagingService.listConversationsMessagingConversationsGet.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = ListConversationsMessagingConversationsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetError,
          TData,
          ServiceOperationQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListConversationsMessagingConversationsGetError>>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      ListConversationsMessagingConversationsGetSchema,
      ListConversationsMessagingConversationsGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Conversations
     * @description List conversations with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.messagingService.listConversationsMessagingConversationsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListConversationsMessagingConversationsGetParameters,
      TQueryFnData = ListConversationsMessagingConversationsGetData,
      TData = OperationInfiniteData<TQueryFnData, ListConversationsMessagingConversationsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListConversationsMessagingConversationsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListConversationsMessagingConversationsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Conversations
     * @description List conversations with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.messagingService.listConversationsMessagingConversationsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListConversationsMessagingConversationsGetParameters,
      TQueryFnData = ListConversationsMessagingConversationsGetData,
      TData = OperationInfiniteData<TQueryFnData, ListConversationsMessagingConversationsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListConversationsMessagingConversationsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListConversationsMessagingConversationsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListConversationsMessagingConversationsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Conversations
     * @description List conversations with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listConversationsMessagingConversationsGetTotal = qraft.messagingService.listConversationsMessagingConversationsGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const listConversationsMessagingConversationsGetByParametersTotal = qraft.messagingService.listConversationsMessagingConversationsGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
        | QueryFiltersByQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Conversations
     * @description List conversations with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listConversationsMessagingConversationsGetResults = qraft.messagingService.listConversationsMessagingConversationsGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listConversationsMessagingConversationsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listConversationsMessagingConversationsGetCombinedResults = qraft.messagingService.listConversationsMessagingConversationsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listConversationsMessagingConversationsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListConversationsMessagingConversationsGetSchema,
          ListConversationsMessagingConversationsGetParameters,
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<ListConversationsMessagingConversationsGetData, ListConversationsMessagingConversationsGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            ListConversationsMessagingConversationsGetData,
            ListConversationsMessagingConversationsGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Conversations
     * @description List conversations with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.messagingService.listConversationsMessagingConversationsGet.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.messagingService.listConversationsMessagingConversationsGet.useSuspenseQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = ListConversationsMessagingConversationsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetError,
          TData,
          ServiceOperationQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListConversationsMessagingConversationsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Conversations
     * @description List conversations with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.messagingService.listConversationsMessagingConversationsGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends ListConversationsMessagingConversationsGetParameters,
      TData = ListConversationsMessagingConversationsGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetError,
          OperationInfiniteData<TData, ListConversationsMessagingConversationsGetParameters>,
          ServiceOperationInfiniteQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListConversationsMessagingConversationsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListConversationsMessagingConversationsGetParameters>,
      OperationError<ListConversationsMessagingConversationsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Conversations
     * @description List conversations with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listConversationsMessagingConversationsGetData = qraft.messagingService.listConversationsMessagingConversationsGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listConversationsMessagingConversationsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listConversationsMessagingConversationsGetCombinedData = qraft.messagingService.listConversationsMessagingConversationsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listConversationsMessagingConversationsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListConversationsMessagingConversationsGetSchema,
          ListConversationsMessagingConversationsGetParameters,
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              ListConversationsMessagingConversationsGetData,
              ListConversationsMessagingConversationsGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListConversationsMessagingConversationsGetSchema,
        ListConversationsMessagingConversationsGetData,
        ListConversationsMessagingConversationsGetParameters,
        ListConversationsMessagingConversationsGetError
      > | void
    ): Promise<ListConversationsMessagingConversationsGetData>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListConversationsMessagingConversationsGetSchema,
        ListConversationsMessagingConversationsGetData,
        ListConversationsMessagingConversationsGetParameters,
        ListConversationsMessagingConversationsGetError
      > | void
    ): Promise<void>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListConversationsMessagingConversationsGetSchema,
        ListConversationsMessagingConversationsGetData,
        ListConversationsMessagingConversationsGetParameters,
        ListConversationsMessagingConversationsGetError
      > | void
    ): Promise<ListConversationsMessagingConversationsGetData>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    fetchInfiniteQuery<TPageParam extends ListConversationsMessagingConversationsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListConversationsMessagingConversationsGetSchema,
        ListConversationsMessagingConversationsGetData,
        ListConversationsMessagingConversationsGetParameters,
        DeepReadonly<TPageParam>,
        ListConversationsMessagingConversationsGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        ListConversationsMessagingConversationsGetData,
        ListConversationsMessagingConversationsGetParameters
      >
    >;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    prefetchInfiniteQuery<TPageParam extends ListConversationsMessagingConversationsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListConversationsMessagingConversationsGetSchema,
        ListConversationsMessagingConversationsGetData,
        ListConversationsMessagingConversationsGetParameters,
        DeepReadonly<TPageParam>,
        ListConversationsMessagingConversationsGetError
      > | void
    ): Promise<void>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    ensureInfiniteQueryData<TPageParam extends ListConversationsMessagingConversationsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListConversationsMessagingConversationsGetSchema,
        ListConversationsMessagingConversationsGetData,
        ListConversationsMessagingConversationsGetParameters,
        DeepReadonly<TPageParam>,
        ListConversationsMessagingConversationsGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        ListConversationsMessagingConversationsGetData,
        ListConversationsMessagingConversationsGetParameters
      >
    >;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void)
    ): ListConversationsMessagingConversationsGetData | undefined;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void)
    ):
      | OperationInfiniteData<
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetParameters
        >
      | undefined;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
        | QueryFiltersByQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ListConversationsMessagingConversationsGetSchema,
              ListConversationsMessagingConversationsGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    ListConversationsMessagingConversationsGetData,
                    ListConversationsMessagingConversationsGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              ListConversationsMessagingConversationsGetSchema,
              ListConversationsMessagingConversationsGetParameters
            >,
            data: ListConversationsMessagingConversationsGetData | undefined,
          ]
        >;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | void)
    ):
      | QueryState<ListConversationsMessagingConversationsGetData, ListConversationsMessagingConversationsGetError>
      | undefined;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListConversationsMessagingConversationsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<
            ListConversationsMessagingConversationsGetData,
            ListConversationsMessagingConversationsGetParameters
          >,
          ListConversationsMessagingConversationsGetError
        >
      | undefined;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | undefined)
        | ServiceOperationQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >,
      updater: Updater<
        NoInfer<ListConversationsMessagingConversationsGetData> | undefined,
        NoInfer<DeepReadonly<ListConversationsMessagingConversationsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): ListConversationsMessagingConversationsGetData | undefined;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListConversationsMessagingConversationsGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              ListConversationsMessagingConversationsGetData,
              ListConversationsMessagingConversationsGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                ListConversationsMessagingConversationsGetData,
                ListConversationsMessagingConversationsGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          ListConversationsMessagingConversationsGetData,
          ListConversationsMessagingConversationsGetParameters
        >
      | undefined;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
        | QueryFiltersByQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >,
      updater: Updater<
        NoInfer<ListConversationsMessagingConversationsGetData> | undefined,
        NoInfer<ListConversationsMessagingConversationsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ListConversationsMessagingConversationsGetData | undefined>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListConversationsMessagingConversationsGetSchema,
        ListConversationsMessagingConversationsGetData,
        TInfinite,
        ListConversationsMessagingConversationsGetParameters,
        ListConversationsMessagingConversationsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
        | QueryFiltersByQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
        | QueryFiltersByQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
        | QueryFiltersByQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
    ): void;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
        | QueryFiltersByQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary List Conversations
     * @description List conversations with optional filters.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
        | QueryFiltersByQueryKey<
            ListConversationsMessagingConversationsGetSchema,
            ListConversationsMessagingConversationsGetData,
            TInfinite,
            ListConversationsMessagingConversationsGetParameters,
            ListConversationsMessagingConversationsGetError
          >
    ): number;
    schema: ListConversationsMessagingConversationsGetSchema;
    types: {
      parameters: ListConversationsMessagingConversationsGetParameters;
      data: ListConversationsMessagingConversationsGetData;
      error: ListConversationsMessagingConversationsGetError;
    };
  };
  /**
   * @summary Get Conversation
   * @description Get a conversation with all its messages.
   */
  getConversationMessagingConversationsConversationIdGet: {
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetConversationMessagingConversationsConversationIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetConversationMessagingConversationsConversationIdGetSchema,
        options: {
          parameters: GetConversationMessagingConversationsConversationIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetConversationMessagingConversationsConversationIdGetData,
        GetConversationMessagingConversationsConversationIdGetError
      >
    >;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    getQueryKey(
      parameters: DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>
    ): ServiceOperationQueryKey<
      GetConversationMessagingConversationsConversationIdGetSchema,
      GetConversationMessagingConversationsConversationIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.messagingService.getConversationMessagingConversationsConversationIdGet.useQuery({
     *     path: {
     *         conversation_id: conversationId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetConversationMessagingConversationsConversationIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetConversationMessagingConversationsConversationIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.messagingService.getConversationMessagingConversationsConversationIdGet.useQuery({
     *     path: {
     *         conversation_id: conversationId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetConversationMessagingConversationsConversationIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetConversationMessagingConversationsConversationIdGetError>>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetConversationMessagingConversationsConversationIdGetSchema,
      GetConversationMessagingConversationsConversationIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.messagingService.getConversationMessagingConversationsConversationIdGet.useInfiniteQuery({
     *     path: {
     *         conversation_id: conversationId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetConversationMessagingConversationsConversationIdGetParameters,
      TQueryFnData = GetConversationMessagingConversationsConversationIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetConversationMessagingConversationsConversationIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetConversationMessagingConversationsConversationIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetConversationMessagingConversationsConversationIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.messagingService.getConversationMessagingConversationsConversationIdGet.useInfiniteQuery({
     *     path: {
     *         conversation_id: conversationId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetConversationMessagingConversationsConversationIdGetParameters,
      TQueryFnData = GetConversationMessagingConversationsConversationIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetConversationMessagingConversationsConversationIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetConversationMessagingConversationsConversationIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetConversationMessagingConversationsConversationIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<
      TData,
      OperationError<GetConversationMessagingConversationsConversationIdGetError>
    >;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getConversationMessagingConversationsConversationIdGetTotal = qraft.messagingService.getConversationMessagingConversationsConversationIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getConversationMessagingConversationsConversationIdGetByParametersTotal = qraft.messagingService.getConversationMessagingConversationsConversationIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             conversation_id: conversationId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getConversationMessagingConversationsConversationIdGetResults = qraft.messagingService.getConversationMessagingConversationsConversationIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 conversation_id: conversationId1
     *             }
     *         },
     *         {
     *             path: {
     *                 conversation_id: conversationId2
     *             }
     *         }
     *     ]
     * });
     * getConversationMessagingConversationsConversationIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getConversationMessagingConversationsConversationIdGetCombinedResults = qraft.messagingService.getConversationMessagingConversationsConversationIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 conversation_id: conversationId1
     *             }
     *         },
     *         {
     *             path: {
     *                 conversation_id: conversationId2
     *             }
     *         }
     *     ]
     * });
     * getConversationMessagingConversationsConversationIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetConversationMessagingConversationsConversationIdGetSchema,
          GetConversationMessagingConversationsConversationIdGetParameters,
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetConversationMessagingConversationsConversationIdGetData,
            GetConversationMessagingConversationsConversationIdGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.messagingService.getConversationMessagingConversationsConversationIdGet.useSuspenseQuery({
     *     path: {
     *         conversation_id: conversationId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetConversationMessagingConversationsConversationIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetConversationMessagingConversationsConversationIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.messagingService.getConversationMessagingConversationsConversationIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         conversation_id: conversationId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetConversationMessagingConversationsConversationIdGetParameters,
      TData = GetConversationMessagingConversationsConversationIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError,
          OperationInfiniteData<TData, GetConversationMessagingConversationsConversationIdGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetConversationMessagingConversationsConversationIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetConversationMessagingConversationsConversationIdGetParameters>,
      OperationError<GetConversationMessagingConversationsConversationIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getConversationMessagingConversationsConversationIdGetData = qraft.messagingService.getConversationMessagingConversationsConversationIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 conversation_id: conversationId1
     *             }
     *         },
     *         {
     *             path: {
     *                 conversation_id: conversationId2
     *             }
     *         }
     *     ]
     * });
     * getConversationMessagingConversationsConversationIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getConversationMessagingConversationsConversationIdGetCombinedData = qraft.messagingService.getConversationMessagingConversationsConversationIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 conversation_id: conversationId1
     *             }
     *         },
     *         {
     *             path: {
     *                 conversation_id: conversationId2
     *             }
     *         }
     *     ]
     * });
     * getConversationMessagingConversationsConversationIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetConversationMessagingConversationsConversationIdGetSchema,
          GetConversationMessagingConversationsConversationIdGetParameters,
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetConversationMessagingConversationsConversationIdGetData,
              GetConversationMessagingConversationsConversationIdGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetConversationMessagingConversationsConversationIdGetSchema,
        GetConversationMessagingConversationsConversationIdGetData,
        GetConversationMessagingConversationsConversationIdGetParameters,
        GetConversationMessagingConversationsConversationIdGetError
      >
    ): Promise<GetConversationMessagingConversationsConversationIdGetData>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetConversationMessagingConversationsConversationIdGetSchema,
        GetConversationMessagingConversationsConversationIdGetData,
        GetConversationMessagingConversationsConversationIdGetParameters,
        GetConversationMessagingConversationsConversationIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetConversationMessagingConversationsConversationIdGetSchema,
        GetConversationMessagingConversationsConversationIdGetData,
        GetConversationMessagingConversationsConversationIdGetParameters,
        GetConversationMessagingConversationsConversationIdGetError
      >
    ): Promise<GetConversationMessagingConversationsConversationIdGetData>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    fetchInfiniteQuery<TPageParam extends GetConversationMessagingConversationsConversationIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetConversationMessagingConversationsConversationIdGetSchema,
        GetConversationMessagingConversationsConversationIdGetData,
        GetConversationMessagingConversationsConversationIdGetParameters,
        DeepReadonly<TPageParam>,
        GetConversationMessagingConversationsConversationIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetConversationMessagingConversationsConversationIdGetData,
        GetConversationMessagingConversationsConversationIdGetParameters
      >
    >;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    prefetchInfiniteQuery<TPageParam extends GetConversationMessagingConversationsConversationIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetConversationMessagingConversationsConversationIdGetSchema,
        GetConversationMessagingConversationsConversationIdGetData,
        GetConversationMessagingConversationsConversationIdGetParameters,
        DeepReadonly<TPageParam>,
        GetConversationMessagingConversationsConversationIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    ensureInfiniteQueryData<TPageParam extends GetConversationMessagingConversationsConversationIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetConversationMessagingConversationsConversationIdGetSchema,
        GetConversationMessagingConversationsConversationIdGetData,
        GetConversationMessagingConversationsConversationIdGetParameters,
        DeepReadonly<TPageParam>,
        GetConversationMessagingConversationsConversationIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetConversationMessagingConversationsConversationIdGetData,
        GetConversationMessagingConversationsConversationIdGetParameters
      >
    >;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>
    ): GetConversationMessagingConversationsConversationIdGetData | undefined;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>
    ):
      | OperationInfiniteData<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetParameters
        >
      | undefined;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetConversationMessagingConversationsConversationIdGetSchema,
              GetConversationMessagingConversationsConversationIdGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetConversationMessagingConversationsConversationIdGetData,
                    GetConversationMessagingConversationsConversationIdGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetConversationMessagingConversationsConversationIdGetSchema,
              GetConversationMessagingConversationsConversationIdGetParameters
            >,
            data: GetConversationMessagingConversationsConversationIdGetData | undefined,
          ]
        >;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>
    ):
      | QueryState<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetError
        >
      | undefined;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetConversationMessagingConversationsConversationIdGetData,
            GetConversationMessagingConversationsConversationIdGetParameters
          >,
          GetConversationMessagingConversationsConversationIdGetError
        >
      | undefined;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>
        | ServiceOperationQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >,
      updater: Updater<
        NoInfer<GetConversationMessagingConversationsConversationIdGetData> | undefined,
        NoInfer<DeepReadonly<GetConversationMessagingConversationsConversationIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetConversationMessagingConversationsConversationIdGetData | undefined;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetConversationMessagingConversationsConversationIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetConversationMessagingConversationsConversationIdGetData,
              GetConversationMessagingConversationsConversationIdGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetConversationMessagingConversationsConversationIdGetData,
                GetConversationMessagingConversationsConversationIdGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetConversationMessagingConversationsConversationIdGetData,
          GetConversationMessagingConversationsConversationIdGetParameters
        >
      | undefined;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >,
      updater: Updater<
        NoInfer<GetConversationMessagingConversationsConversationIdGetData> | undefined,
        NoInfer<GetConversationMessagingConversationsConversationIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetConversationMessagingConversationsConversationIdGetData | undefined>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetConversationMessagingConversationsConversationIdGetSchema,
        GetConversationMessagingConversationsConversationIdGetData,
        TInfinite,
        GetConversationMessagingConversationsConversationIdGetParameters,
        GetConversationMessagingConversationsConversationIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
    ): void;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Conversation
     * @description Get a conversation with all its messages.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetConversationMessagingConversationsConversationIdGetSchema,
            GetConversationMessagingConversationsConversationIdGetData,
            TInfinite,
            GetConversationMessagingConversationsConversationIdGetParameters,
            GetConversationMessagingConversationsConversationIdGetError
          >
    ): number;
    schema: GetConversationMessagingConversationsConversationIdGetSchema;
    types: {
      parameters: GetConversationMessagingConversationsConversationIdGetParameters;
      data: GetConversationMessagingConversationsConversationIdGetData;
      error: GetConversationMessagingConversationsConversationIdGetError;
    };
  };
  /**
   * @summary List Templates
   * @description List message templates with optional filters.
   */
  listTemplatesMessagingTemplatesGet: {
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<ListTemplatesMessagingTemplatesGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListTemplatesMessagingTemplatesGetSchema,
        options: {
          parameters: ListTemplatesMessagingTemplatesGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetError>>
    ): Promise<RequestFnResponse<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetError>>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    getQueryKey(
      parameters: DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void
    ): ServiceOperationQueryKey<ListTemplatesMessagingTemplatesGetSchema, ListTemplatesMessagingTemplatesGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Templates
     * @description List message templates with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.messagingService.listTemplatesMessagingTemplatesGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.messagingService.listTemplatesMessagingTemplatesGet.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = ListTemplatesMessagingTemplatesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListTemplatesMessagingTemplatesGetData,
          ListTemplatesMessagingTemplatesGetError,
          TData,
          ServiceOperationQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListTemplatesMessagingTemplatesGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Templates
     * @description List message templates with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.messagingService.listTemplatesMessagingTemplatesGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.messagingService.listTemplatesMessagingTemplatesGet.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = ListTemplatesMessagingTemplatesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListTemplatesMessagingTemplatesGetData,
          ListTemplatesMessagingTemplatesGetError,
          TData,
          ServiceOperationQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListTemplatesMessagingTemplatesGetError>>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      ListTemplatesMessagingTemplatesGetSchema,
      ListTemplatesMessagingTemplatesGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Templates
     * @description List message templates with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.messagingService.listTemplatesMessagingTemplatesGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListTemplatesMessagingTemplatesGetParameters,
      TQueryFnData = ListTemplatesMessagingTemplatesGetData,
      TData = OperationInfiniteData<TQueryFnData, ListTemplatesMessagingTemplatesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListTemplatesMessagingTemplatesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListTemplatesMessagingTemplatesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Templates
     * @description List message templates with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.messagingService.listTemplatesMessagingTemplatesGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListTemplatesMessagingTemplatesGetParameters,
      TQueryFnData = ListTemplatesMessagingTemplatesGetData,
      TData = OperationInfiniteData<TQueryFnData, ListTemplatesMessagingTemplatesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListTemplatesMessagingTemplatesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListTemplatesMessagingTemplatesGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListTemplatesMessagingTemplatesGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Templates
     * @description List message templates with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listTemplatesMessagingTemplatesGetTotal = qraft.messagingService.listTemplatesMessagingTemplatesGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const listTemplatesMessagingTemplatesGetByParametersTotal = qraft.messagingService.listTemplatesMessagingTemplatesGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Templates
     * @description List message templates with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listTemplatesMessagingTemplatesGetResults = qraft.messagingService.listTemplatesMessagingTemplatesGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listTemplatesMessagingTemplatesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listTemplatesMessagingTemplatesGetCombinedResults = qraft.messagingService.listTemplatesMessagingTemplatesGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listTemplatesMessagingTemplatesGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListTemplatesMessagingTemplatesGetSchema,
          ListTemplatesMessagingTemplatesGetParameters,
          ListTemplatesMessagingTemplatesGetData,
          ListTemplatesMessagingTemplatesGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Templates
     * @description List message templates with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.messagingService.listTemplatesMessagingTemplatesGet.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.messagingService.listTemplatesMessagingTemplatesGet.useSuspenseQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = ListTemplatesMessagingTemplatesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListTemplatesMessagingTemplatesGetData,
          ListTemplatesMessagingTemplatesGetError,
          TData,
          ServiceOperationQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListTemplatesMessagingTemplatesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Templates
     * @description List message templates with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.messagingService.listTemplatesMessagingTemplatesGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends ListTemplatesMessagingTemplatesGetParameters,
      TData = ListTemplatesMessagingTemplatesGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListTemplatesMessagingTemplatesGetData,
          ListTemplatesMessagingTemplatesGetError,
          OperationInfiniteData<TData, ListTemplatesMessagingTemplatesGetParameters>,
          ServiceOperationInfiniteQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListTemplatesMessagingTemplatesGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListTemplatesMessagingTemplatesGetParameters>,
      OperationError<ListTemplatesMessagingTemplatesGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Templates
     * @description List message templates with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listTemplatesMessagingTemplatesGetData = qraft.messagingService.listTemplatesMessagingTemplatesGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listTemplatesMessagingTemplatesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listTemplatesMessagingTemplatesGetCombinedData = qraft.messagingService.listTemplatesMessagingTemplatesGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listTemplatesMessagingTemplatesGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListTemplatesMessagingTemplatesGetSchema,
          ListTemplatesMessagingTemplatesGetParameters,
          ListTemplatesMessagingTemplatesGetData,
          ListTemplatesMessagingTemplatesGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListTemplatesMessagingTemplatesGetSchema,
        ListTemplatesMessagingTemplatesGetData,
        ListTemplatesMessagingTemplatesGetParameters,
        ListTemplatesMessagingTemplatesGetError
      > | void
    ): Promise<ListTemplatesMessagingTemplatesGetData>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListTemplatesMessagingTemplatesGetSchema,
        ListTemplatesMessagingTemplatesGetData,
        ListTemplatesMessagingTemplatesGetParameters,
        ListTemplatesMessagingTemplatesGetError
      > | void
    ): Promise<void>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListTemplatesMessagingTemplatesGetSchema,
        ListTemplatesMessagingTemplatesGetData,
        ListTemplatesMessagingTemplatesGetParameters,
        ListTemplatesMessagingTemplatesGetError
      > | void
    ): Promise<ListTemplatesMessagingTemplatesGetData>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    fetchInfiniteQuery<TPageParam extends ListTemplatesMessagingTemplatesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListTemplatesMessagingTemplatesGetSchema,
        ListTemplatesMessagingTemplatesGetData,
        ListTemplatesMessagingTemplatesGetParameters,
        DeepReadonly<TPageParam>,
        ListTemplatesMessagingTemplatesGetError
      > | void
    ): Promise<
      OperationInfiniteData<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetParameters>
    >;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    prefetchInfiniteQuery<TPageParam extends ListTemplatesMessagingTemplatesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListTemplatesMessagingTemplatesGetSchema,
        ListTemplatesMessagingTemplatesGetData,
        ListTemplatesMessagingTemplatesGetParameters,
        DeepReadonly<TPageParam>,
        ListTemplatesMessagingTemplatesGetError
      > | void
    ): Promise<void>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    ensureInfiniteQueryData<TPageParam extends ListTemplatesMessagingTemplatesGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListTemplatesMessagingTemplatesGetSchema,
        ListTemplatesMessagingTemplatesGetData,
        ListTemplatesMessagingTemplatesGetParameters,
        DeepReadonly<TPageParam>,
        ListTemplatesMessagingTemplatesGetError
      > | void
    ): Promise<
      OperationInfiniteData<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetParameters>
    >;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void)
    ): ListTemplatesMessagingTemplatesGetData | undefined;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void)
    ):
      | OperationInfiniteData<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetParameters>
      | undefined;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ListTemplatesMessagingTemplatesGetSchema,
              ListTemplatesMessagingTemplatesGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    ListTemplatesMessagingTemplatesGetData,
                    ListTemplatesMessagingTemplatesGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              ListTemplatesMessagingTemplatesGetSchema,
              ListTemplatesMessagingTemplatesGetParameters
            >,
            data: ListTemplatesMessagingTemplatesGetData | undefined,
          ]
        >;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void)
    ): QueryState<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetError> | undefined;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListTemplatesMessagingTemplatesGetParameters>
        | ServiceOperationInfiniteQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetParameters>,
          ListTemplatesMessagingTemplatesGetError
        >
      | undefined;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | undefined)
        | ServiceOperationQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >,
      updater: Updater<
        NoInfer<ListTemplatesMessagingTemplatesGetData> | undefined,
        NoInfer<DeepReadonly<ListTemplatesMessagingTemplatesGetData>> | undefined
      >,
      options?: SetDataOptions
    ): ListTemplatesMessagingTemplatesGetData | undefined;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetParameters>
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                ListTemplatesMessagingTemplatesGetData,
                ListTemplatesMessagingTemplatesGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetParameters>
      | undefined;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >,
      updater: Updater<
        NoInfer<ListTemplatesMessagingTemplatesGetData> | undefined,
        NoInfer<ListTemplatesMessagingTemplatesGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ListTemplatesMessagingTemplatesGetData | undefined>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListTemplatesMessagingTemplatesGetSchema,
        ListTemplatesMessagingTemplatesGetData,
        TInfinite,
        ListTemplatesMessagingTemplatesGetParameters,
        ListTemplatesMessagingTemplatesGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
    ): void;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
    ): number;
    schema: ListTemplatesMessagingTemplatesGetSchema;
    types: {
      parameters: ListTemplatesMessagingTemplatesGetParameters;
      data: ListTemplatesMessagingTemplatesGetData;
      error: ListTemplatesMessagingTemplatesGetError;
    };
  };
  /**
   * @summary Create Template
   * @description Create a new message template.
   */
  createTemplateMessagingTemplatesPost: {
    /**
     * @summary Create Template
     * @description Create a new message template.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateTemplateMessagingTemplatesPostBody,
        CreateTemplateMessagingTemplatesPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateTemplateMessagingTemplatesPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateTemplateMessagingTemplatesPostBody,
          CreateTemplateMessagingTemplatesPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<CreateTemplateMessagingTemplatesPostData, CreateTemplateMessagingTemplatesPostError>
      >
    ): Promise<RequestFnResponse<CreateTemplateMessagingTemplatesPostData, CreateTemplateMessagingTemplatesPostError>>;
    /**
     * @summary Create Template
     * @description Create a new message template.
     */
    getMutationKey(
      parameters: DeepReadonly<CreateTemplateMessagingTemplatesPostParameters> | void
    ): ServiceOperationMutationKey<
      CreateTemplateMessagingTemplatesPostSchema,
      CreateTemplateMessagingTemplatesPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Template
     * @description Create a new message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.createTemplateMessagingTemplatesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.createTemplateMessagingTemplatesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateTemplateMessagingTemplatesPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateTemplateMessagingTemplatesPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateTemplateMessagingTemplatesPostSchema,
        CreateTemplateMessagingTemplatesPostData,
        CreateTemplateMessagingTemplatesPostParameters,
        TVariables,
        OperationError<CreateTemplateMessagingTemplatesPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateTemplateMessagingTemplatesPostData,
      OperationError<CreateTemplateMessagingTemplatesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Template
     * @description Create a new message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.createTemplateMessagingTemplatesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.createTemplateMessagingTemplatesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateTemplateMessagingTemplatesPostBody,
        CreateTemplateMessagingTemplatesPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateTemplateMessagingTemplatesPostSchema,
        CreateTemplateMessagingTemplatesPostData,
        CreateTemplateMessagingTemplatesPostParameters,
        TVariables,
        OperationError<CreateTemplateMessagingTemplatesPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateTemplateMessagingTemplatesPostData,
      OperationError<CreateTemplateMessagingTemplatesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create Template
     * @description Create a new message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createTemplateMessagingTemplatesPostTotal = qraft.messagingService.createTemplateMessagingTemplatesPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createTemplateMessagingTemplatesPostTotal = qraft.messagingService.createTemplateMessagingTemplatesPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateTemplateMessagingTemplatesPostBody,
            CreateTemplateMessagingTemplatesPostData,
            CreateTemplateMessagingTemplatesPostParameters,
            OperationError<CreateTemplateMessagingTemplatesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateTemplateMessagingTemplatesPostSchema,
            CreateTemplateMessagingTemplatesPostBody,
            CreateTemplateMessagingTemplatesPostData,
            CreateTemplateMessagingTemplatesPostParameters,
            OperationError<CreateTemplateMessagingTemplatesPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create Template
     * @description Create a new message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createTemplateMessagingTemplatesPostPendingMutationVariables = qraft.messagingService.createTemplateMessagingTemplatesPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createTemplateMessagingTemplatesPostMutationData = qraft.messagingService.createTemplateMessagingTemplatesPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateTemplateMessagingTemplatesPostData,
        OperationError<CreateTemplateMessagingTemplatesPostError>,
        MutationVariables<CreateTemplateMessagingTemplatesPostBody, CreateTemplateMessagingTemplatesPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateTemplateMessagingTemplatesPostBody,
            CreateTemplateMessagingTemplatesPostData,
            CreateTemplateMessagingTemplatesPostParameters,
            OperationError<CreateTemplateMessagingTemplatesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateTemplateMessagingTemplatesPostSchema,
            CreateTemplateMessagingTemplatesPostBody,
            CreateTemplateMessagingTemplatesPostData,
            CreateTemplateMessagingTemplatesPostParameters,
            OperationError<CreateTemplateMessagingTemplatesPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateTemplateMessagingTemplatesPostData,
          OperationError<CreateTemplateMessagingTemplatesPostError>,
          MutationVariables<CreateTemplateMessagingTemplatesPostBody, CreateTemplateMessagingTemplatesPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Create Template
     * @description Create a new message template.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateTemplateMessagingTemplatesPostBody,
            CreateTemplateMessagingTemplatesPostData,
            CreateTemplateMessagingTemplatesPostParameters,
            OperationError<CreateTemplateMessagingTemplatesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateTemplateMessagingTemplatesPostSchema,
            CreateTemplateMessagingTemplatesPostBody,
            CreateTemplateMessagingTemplatesPostData,
            CreateTemplateMessagingTemplatesPostParameters,
            OperationError<CreateTemplateMessagingTemplatesPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create Template
     * @description Create a new message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.messagingService.createTemplateMessagingTemplatesPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.messagingService.createTemplateMessagingTemplatesPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateTemplateMessagingTemplatesPostBody,
              CreateTemplateMessagingTemplatesPostData,
              CreateTemplateMessagingTemplatesPostParameters,
              OperationError<CreateTemplateMessagingTemplatesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateTemplateMessagingTemplatesPostSchema,
              CreateTemplateMessagingTemplatesPostBody,
              CreateTemplateMessagingTemplatesPostData,
              CreateTemplateMessagingTemplatesPostParameters,
              OperationError<CreateTemplateMessagingTemplatesPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateTemplateMessagingTemplatesPostData,
            CreateTemplateMessagingTemplatesPostError,
            MutationVariables<CreateTemplateMessagingTemplatesPostBody, CreateTemplateMessagingTemplatesPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateTemplateMessagingTemplatesPostBody,
              CreateTemplateMessagingTemplatesPostData,
              CreateTemplateMessagingTemplatesPostParameters,
              OperationError<CreateTemplateMessagingTemplatesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateTemplateMessagingTemplatesPostSchema,
              CreateTemplateMessagingTemplatesPostBody,
              CreateTemplateMessagingTemplatesPostData,
              CreateTemplateMessagingTemplatesPostParameters,
              OperationError<CreateTemplateMessagingTemplatesPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateTemplateMessagingTemplatesPostData,
          CreateTemplateMessagingTemplatesPostError,
          MutationVariables<CreateTemplateMessagingTemplatesPostBody, CreateTemplateMessagingTemplatesPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateTemplateMessagingTemplatesPostSchema;
    types: {
      parameters: CreateTemplateMessagingTemplatesPostParameters;
      data: CreateTemplateMessagingTemplatesPostData;
      error: CreateTemplateMessagingTemplatesPostError;
      body: CreateTemplateMessagingTemplatesPostBody;
    };
  };
  /**
   * @summary Get Template
   * @description Get a message template by ID.
   */
  getTemplateMessagingTemplatesTemplateIdGet: {
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetTemplateMessagingTemplatesTemplateIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetTemplateMessagingTemplatesTemplateIdGetSchema,
        options: {
          parameters: GetTemplateMessagingTemplatesTemplateIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetError
        >
      >
    ): Promise<
      RequestFnResponse<GetTemplateMessagingTemplatesTemplateIdGetData, GetTemplateMessagingTemplatesTemplateIdGetError>
    >;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    getQueryKey(
      parameters: DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>
    ): ServiceOperationQueryKey<
      GetTemplateMessagingTemplatesTemplateIdGetSchema,
      GetTemplateMessagingTemplatesTemplateIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Template
     * @description Get a message template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.messagingService.getTemplateMessagingTemplatesTemplateIdGet.useQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetTemplateMessagingTemplatesTemplateIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetTemplateMessagingTemplatesTemplateIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Template
     * @description Get a message template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.messagingService.getTemplateMessagingTemplatesTemplateIdGet.useQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetTemplateMessagingTemplatesTemplateIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetTemplateMessagingTemplatesTemplateIdGetError>>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetTemplateMessagingTemplatesTemplateIdGetSchema,
      GetTemplateMessagingTemplatesTemplateIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Template
     * @description Get a message template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.messagingService.getTemplateMessagingTemplatesTemplateIdGet.useInfiniteQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetTemplateMessagingTemplatesTemplateIdGetParameters,
      TQueryFnData = GetTemplateMessagingTemplatesTemplateIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetTemplateMessagingTemplatesTemplateIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetTemplateMessagingTemplatesTemplateIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetTemplateMessagingTemplatesTemplateIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Template
     * @description Get a message template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.messagingService.getTemplateMessagingTemplatesTemplateIdGet.useInfiniteQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetTemplateMessagingTemplatesTemplateIdGetParameters,
      TQueryFnData = GetTemplateMessagingTemplatesTemplateIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetTemplateMessagingTemplatesTemplateIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetTemplateMessagingTemplatesTemplateIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetTemplateMessagingTemplatesTemplateIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Template
     * @description Get a message template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getTemplateMessagingTemplatesTemplateIdGetTotal = qraft.messagingService.getTemplateMessagingTemplatesTemplateIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getTemplateMessagingTemplatesTemplateIdGetByParametersTotal = qraft.messagingService.getTemplateMessagingTemplatesTemplateIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Template
     * @description Get a message template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getTemplateMessagingTemplatesTemplateIdGetResults = qraft.messagingService.getTemplateMessagingTemplatesTemplateIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getTemplateMessagingTemplatesTemplateIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getTemplateMessagingTemplatesTemplateIdGetCombinedResults = qraft.messagingService.getTemplateMessagingTemplatesTemplateIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getTemplateMessagingTemplatesTemplateIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetTemplateMessagingTemplatesTemplateIdGetSchema,
          GetTemplateMessagingTemplatesTemplateIdGetParameters,
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<GetTemplateMessagingTemplatesTemplateIdGetData, GetTemplateMessagingTemplatesTemplateIdGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetTemplateMessagingTemplatesTemplateIdGetData,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Template
     * @description Get a message template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.messagingService.getTemplateMessagingTemplatesTemplateIdGet.useSuspenseQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetTemplateMessagingTemplatesTemplateIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetTemplateMessagingTemplatesTemplateIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Template
     * @description Get a message template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.messagingService.getTemplateMessagingTemplatesTemplateIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetTemplateMessagingTemplatesTemplateIdGetParameters,
      TData = GetTemplateMessagingTemplatesTemplateIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetError,
          OperationInfiniteData<TData, GetTemplateMessagingTemplatesTemplateIdGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetTemplateMessagingTemplatesTemplateIdGetParameters>,
      OperationError<GetTemplateMessagingTemplatesTemplateIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Template
     * @description Get a message template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getTemplateMessagingTemplatesTemplateIdGetData = qraft.messagingService.getTemplateMessagingTemplatesTemplateIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getTemplateMessagingTemplatesTemplateIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getTemplateMessagingTemplatesTemplateIdGetCombinedData = qraft.messagingService.getTemplateMessagingTemplatesTemplateIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getTemplateMessagingTemplatesTemplateIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetTemplateMessagingTemplatesTemplateIdGetSchema,
          GetTemplateMessagingTemplatesTemplateIdGetParameters,
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetTemplateMessagingTemplatesTemplateIdGetData,
              GetTemplateMessagingTemplatesTemplateIdGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetTemplateMessagingTemplatesTemplateIdGetSchema,
        GetTemplateMessagingTemplatesTemplateIdGetData,
        GetTemplateMessagingTemplatesTemplateIdGetParameters,
        GetTemplateMessagingTemplatesTemplateIdGetError
      >
    ): Promise<GetTemplateMessagingTemplatesTemplateIdGetData>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetTemplateMessagingTemplatesTemplateIdGetSchema,
        GetTemplateMessagingTemplatesTemplateIdGetData,
        GetTemplateMessagingTemplatesTemplateIdGetParameters,
        GetTemplateMessagingTemplatesTemplateIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetTemplateMessagingTemplatesTemplateIdGetSchema,
        GetTemplateMessagingTemplatesTemplateIdGetData,
        GetTemplateMessagingTemplatesTemplateIdGetParameters,
        GetTemplateMessagingTemplatesTemplateIdGetError
      >
    ): Promise<GetTemplateMessagingTemplatesTemplateIdGetData>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    fetchInfiniteQuery<TPageParam extends GetTemplateMessagingTemplatesTemplateIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetTemplateMessagingTemplatesTemplateIdGetSchema,
        GetTemplateMessagingTemplatesTemplateIdGetData,
        GetTemplateMessagingTemplatesTemplateIdGetParameters,
        DeepReadonly<TPageParam>,
        GetTemplateMessagingTemplatesTemplateIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetTemplateMessagingTemplatesTemplateIdGetData,
        GetTemplateMessagingTemplatesTemplateIdGetParameters
      >
    >;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    prefetchInfiniteQuery<TPageParam extends GetTemplateMessagingTemplatesTemplateIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetTemplateMessagingTemplatesTemplateIdGetSchema,
        GetTemplateMessagingTemplatesTemplateIdGetData,
        GetTemplateMessagingTemplatesTemplateIdGetParameters,
        DeepReadonly<TPageParam>,
        GetTemplateMessagingTemplatesTemplateIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    ensureInfiniteQueryData<TPageParam extends GetTemplateMessagingTemplatesTemplateIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetTemplateMessagingTemplatesTemplateIdGetSchema,
        GetTemplateMessagingTemplatesTemplateIdGetData,
        GetTemplateMessagingTemplatesTemplateIdGetParameters,
        DeepReadonly<TPageParam>,
        GetTemplateMessagingTemplatesTemplateIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetTemplateMessagingTemplatesTemplateIdGetData,
        GetTemplateMessagingTemplatesTemplateIdGetParameters
      >
    >;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>
    ): GetTemplateMessagingTemplatesTemplateIdGetData | undefined;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>
    ):
      | OperationInfiniteData<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetParameters
        >
      | undefined;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetTemplateMessagingTemplatesTemplateIdGetSchema,
              GetTemplateMessagingTemplatesTemplateIdGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetTemplateMessagingTemplatesTemplateIdGetData,
                    GetTemplateMessagingTemplatesTemplateIdGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetTemplateMessagingTemplatesTemplateIdGetSchema,
              GetTemplateMessagingTemplatesTemplateIdGetParameters
            >,
            data: GetTemplateMessagingTemplatesTemplateIdGetData | undefined,
          ]
        >;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>
    ):
      | QueryState<GetTemplateMessagingTemplatesTemplateIdGetData, GetTemplateMessagingTemplatesTemplateIdGetError>
      | undefined;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetTemplateMessagingTemplatesTemplateIdGetData,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >,
          GetTemplateMessagingTemplatesTemplateIdGetError
        >
      | undefined;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>
        | ServiceOperationQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >,
      updater: Updater<
        NoInfer<GetTemplateMessagingTemplatesTemplateIdGetData> | undefined,
        NoInfer<DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetTemplateMessagingTemplatesTemplateIdGetData | undefined;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetTemplateMessagingTemplatesTemplateIdGetData,
              GetTemplateMessagingTemplatesTemplateIdGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetTemplateMessagingTemplatesTemplateIdGetData,
                GetTemplateMessagingTemplatesTemplateIdGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetParameters
        >
      | undefined;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >,
      updater: Updater<
        NoInfer<GetTemplateMessagingTemplatesTemplateIdGetData> | undefined,
        NoInfer<GetTemplateMessagingTemplatesTemplateIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetTemplateMessagingTemplatesTemplateIdGetData | undefined>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetTemplateMessagingTemplatesTemplateIdGetSchema,
        GetTemplateMessagingTemplatesTemplateIdGetData,
        TInfinite,
        GetTemplateMessagingTemplatesTemplateIdGetParameters,
        GetTemplateMessagingTemplatesTemplateIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
    ): void;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
    ): number;
    schema: GetTemplateMessagingTemplatesTemplateIdGetSchema;
    types: {
      parameters: GetTemplateMessagingTemplatesTemplateIdGetParameters;
      data: GetTemplateMessagingTemplatesTemplateIdGetData;
      error: GetTemplateMessagingTemplatesTemplateIdGetError;
    };
  };
  /**
   * @summary Update Template
   * @description Update a message template.
   */
  updateTemplateMessagingTemplatesTemplateIdPut: {
    /**
     * @summary Update Template
     * @description Update a message template.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateTemplateMessagingTemplatesTemplateIdPutBody,
        UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateTemplateMessagingTemplatesTemplateIdPutSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateTemplateMessagingTemplatesTemplateIdPutBody,
          UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          UpdateTemplateMessagingTemplatesTemplateIdPutData,
          UpdateTemplateMessagingTemplatesTemplateIdPutError
        >
      >
    ): Promise<
      RequestFnResponse<
        UpdateTemplateMessagingTemplatesTemplateIdPutData,
        UpdateTemplateMessagingTemplatesTemplateIdPutError
      >
    >;
    /**
     * @summary Update Template
     * @description Update a message template.
     */
    getMutationKey(
      parameters: DeepReadonly<UpdateTemplateMessagingTemplatesTemplateIdPutParameters> | void
    ): ServiceOperationMutationKey<
      UpdateTemplateMessagingTemplatesTemplateIdPutSchema,
      UpdateTemplateMessagingTemplatesTemplateIdPutParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update Template
     * @description Update a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.updateTemplateMessagingTemplatesTemplateIdPut.useMutation({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.updateTemplateMessagingTemplatesTemplateIdPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         template_id: templateId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateTemplateMessagingTemplatesTemplateIdPutBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateTemplateMessagingTemplatesTemplateIdPutParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateTemplateMessagingTemplatesTemplateIdPutSchema,
        UpdateTemplateMessagingTemplatesTemplateIdPutData,
        UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
        TVariables,
        OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
        TContext
      >
    ): UseMutationResult<
      UpdateTemplateMessagingTemplatesTemplateIdPutData,
      OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update Template
     * @description Update a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.updateTemplateMessagingTemplatesTemplateIdPut.useMutation({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.updateTemplateMessagingTemplatesTemplateIdPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         template_id: templateId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        UpdateTemplateMessagingTemplatesTemplateIdPutBody,
        UpdateTemplateMessagingTemplatesTemplateIdPutParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateTemplateMessagingTemplatesTemplateIdPutSchema,
        UpdateTemplateMessagingTemplatesTemplateIdPutData,
        UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
        TVariables,
        OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
        TContext
      >
    ): UseMutationResult<
      UpdateTemplateMessagingTemplatesTemplateIdPutData,
      OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update Template
     * @description Update a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateTemplateMessagingTemplatesTemplateIdPutTotal = qraft.messagingService.updateTemplateMessagingTemplatesTemplateIdPut.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateTemplateMessagingTemplatesTemplateIdPutTotal = qraft.messagingService.updateTemplateMessagingTemplatesTemplateIdPut.useIsMutating({
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateTemplateMessagingTemplatesTemplateIdPutBody,
            UpdateTemplateMessagingTemplatesTemplateIdPutData,
            UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
            OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateTemplateMessagingTemplatesTemplateIdPutSchema,
            UpdateTemplateMessagingTemplatesTemplateIdPutBody,
            UpdateTemplateMessagingTemplatesTemplateIdPutData,
            UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
            OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update Template
     * @description Update a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateTemplateMessagingTemplatesTemplateIdPutPendingMutationVariables = qraft.messagingService.updateTemplateMessagingTemplatesTemplateIdPut.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateTemplateMessagingTemplatesTemplateIdPutMutationData = qraft.messagingService.updateTemplateMessagingTemplatesTemplateIdPut.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 template_id: templateId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateTemplateMessagingTemplatesTemplateIdPutData,
        OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
        MutationVariables<
          UpdateTemplateMessagingTemplatesTemplateIdPutBody,
          UpdateTemplateMessagingTemplatesTemplateIdPutParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateTemplateMessagingTemplatesTemplateIdPutBody,
            UpdateTemplateMessagingTemplatesTemplateIdPutData,
            UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
            OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateTemplateMessagingTemplatesTemplateIdPutSchema,
            UpdateTemplateMessagingTemplatesTemplateIdPutBody,
            UpdateTemplateMessagingTemplatesTemplateIdPutData,
            UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
            OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateTemplateMessagingTemplatesTemplateIdPutData,
          OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
          MutationVariables<
            UpdateTemplateMessagingTemplatesTemplateIdPutBody,
            UpdateTemplateMessagingTemplatesTemplateIdPutParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Update Template
     * @description Update a message template.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateTemplateMessagingTemplatesTemplateIdPutBody,
            UpdateTemplateMessagingTemplatesTemplateIdPutData,
            UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
            OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateTemplateMessagingTemplatesTemplateIdPutSchema,
            UpdateTemplateMessagingTemplatesTemplateIdPutBody,
            UpdateTemplateMessagingTemplatesTemplateIdPutData,
            UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
            OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update Template
     * @description Update a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.messagingService.updateTemplateMessagingTemplatesTemplateIdPut.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.messagingService.updateTemplateMessagingTemplatesTemplateIdPut.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateTemplateMessagingTemplatesTemplateIdPutBody,
              UpdateTemplateMessagingTemplatesTemplateIdPutData,
              UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
              OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateTemplateMessagingTemplatesTemplateIdPutSchema,
              UpdateTemplateMessagingTemplatesTemplateIdPutBody,
              UpdateTemplateMessagingTemplatesTemplateIdPutData,
              UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
              OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
              TContext
            >
      ):
        | Mutation<
            UpdateTemplateMessagingTemplatesTemplateIdPutData,
            UpdateTemplateMessagingTemplatesTemplateIdPutError,
            MutationVariables<
              UpdateTemplateMessagingTemplatesTemplateIdPutBody,
              UpdateTemplateMessagingTemplatesTemplateIdPutParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateTemplateMessagingTemplatesTemplateIdPutBody,
              UpdateTemplateMessagingTemplatesTemplateIdPutData,
              UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
              OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateTemplateMessagingTemplatesTemplateIdPutSchema,
              UpdateTemplateMessagingTemplatesTemplateIdPutBody,
              UpdateTemplateMessagingTemplatesTemplateIdPutData,
              UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
              OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateTemplateMessagingTemplatesTemplateIdPutData,
          UpdateTemplateMessagingTemplatesTemplateIdPutError,
          MutationVariables<
            UpdateTemplateMessagingTemplatesTemplateIdPutBody,
            UpdateTemplateMessagingTemplatesTemplateIdPutParameters
          >,
          TContext
        >
      >;
    };
    schema: UpdateTemplateMessagingTemplatesTemplateIdPutSchema;
    types: {
      parameters: UpdateTemplateMessagingTemplatesTemplateIdPutParameters;
      data: UpdateTemplateMessagingTemplatesTemplateIdPutData;
      error: UpdateTemplateMessagingTemplatesTemplateIdPutError;
      body: UpdateTemplateMessagingTemplatesTemplateIdPutBody;
    };
  };
  /**
   * @summary Delete Template
   * @description Delete a message template.
   */
  deleteTemplateMessagingTemplatesTemplateIdDelete: {
    /**
     * @summary Delete Template
     * @description Delete a message template.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
        DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
          DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
          DeleteTemplateMessagingTemplatesTemplateIdDeleteError
        >
      >
    ): Promise<
      RequestFnResponse<
        DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
        DeleteTemplateMessagingTemplatesTemplateIdDeleteError
      >
    >;
    /**
     * @summary Delete Template
     * @description Delete a message template.
     */
    getMutationKey(
      parameters: DeepReadonly<DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters> | void
    ): ServiceOperationMutationKey<
      DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema,
      DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete Template
     * @description Delete a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.deleteTemplateMessagingTemplatesTemplateIdDelete.useMutation({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.deleteTemplateMessagingTemplatesTemplateIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         template_id: templateId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends DeleteTemplateMessagingTemplatesTemplateIdDeleteBody, TContext = unknown>(
      parameters: DeepReadonly<DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema,
        DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
        DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
        TVariables,
        OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
      OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete Template
     * @description Delete a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.deleteTemplateMessagingTemplatesTemplateIdDelete.useMutation({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.deleteTemplateMessagingTemplatesTemplateIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         template_id: templateId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
        DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema,
        DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
        DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
        TVariables,
        OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
      OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Delete Template
     * @description Delete a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const deleteTemplateMessagingTemplatesTemplateIdDeleteTotal = qraft.messagingService.deleteTemplateMessagingTemplatesTemplateIdDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const deleteTemplateMessagingTemplatesTemplateIdDeleteTotal = qraft.messagingService.deleteTemplateMessagingTemplatesTemplateIdDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
            OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
            OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Delete Template
     * @description Delete a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const deleteTemplateMessagingTemplatesTemplateIdDeletePendingMutationVariables = qraft.messagingService.deleteTemplateMessagingTemplatesTemplateIdDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const deleteTemplateMessagingTemplatesTemplateIdDeleteMutationData = qraft.messagingService.deleteTemplateMessagingTemplatesTemplateIdDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 template_id: templateId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
        OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
        MutationVariables<
          DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
          DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
            OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
            OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
          OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
          MutationVariables<
            DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Delete Template
     * @description Delete a message template.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
            OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
            OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Delete Template
     * @description Delete a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.messagingService.deleteTemplateMessagingTemplatesTemplateIdDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.messagingService.deleteTemplateMessagingTemplatesTemplateIdDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
              OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
              OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
              TContext
            >
      ):
        | Mutation<
            DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteError,
            MutationVariables<
              DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
              OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
              OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
          DeleteTemplateMessagingTemplatesTemplateIdDeleteError,
          MutationVariables<
            DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters
          >,
          TContext
        >
      >;
    };
    schema: DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema;
    types: {
      parameters: DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters;
      data: DeleteTemplateMessagingTemplatesTemplateIdDeleteData;
      error: DeleteTemplateMessagingTemplatesTemplateIdDeleteError;
      body: DeleteTemplateMessagingTemplatesTemplateIdDeleteBody;
    };
  };
  /**
   * @summary Preview Template
   * @description Preview a template with given variables.
   */
  previewTemplateMessagingTemplatesPreviewPost: {
    /**
     * @summary Preview Template
     * @description Preview a template with given variables.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        PreviewTemplateMessagingTemplatesPreviewPostBody,
        PreviewTemplateMessagingTemplatesPreviewPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: PreviewTemplateMessagingTemplatesPreviewPostSchema,
        options: ServiceOperationMutationFnOptions<
          PreviewTemplateMessagingTemplatesPreviewPostBody,
          PreviewTemplateMessagingTemplatesPreviewPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          PreviewTemplateMessagingTemplatesPreviewPostData,
          PreviewTemplateMessagingTemplatesPreviewPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        PreviewTemplateMessagingTemplatesPreviewPostData,
        PreviewTemplateMessagingTemplatesPreviewPostError
      >
    >;
    /**
     * @summary Preview Template
     * @description Preview a template with given variables.
     */
    getMutationKey(
      parameters: DeepReadonly<PreviewTemplateMessagingTemplatesPreviewPostParameters> | void
    ): ServiceOperationMutationKey<
      PreviewTemplateMessagingTemplatesPreviewPostSchema,
      PreviewTemplateMessagingTemplatesPreviewPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Preview Template
     * @description Preview a template with given variables.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.previewTemplateMessagingTemplatesPreviewPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.previewTemplateMessagingTemplatesPreviewPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends PreviewTemplateMessagingTemplatesPreviewPostBody, TContext = unknown>(
      parameters: DeepReadonly<PreviewTemplateMessagingTemplatesPreviewPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        PreviewTemplateMessagingTemplatesPreviewPostSchema,
        PreviewTemplateMessagingTemplatesPreviewPostData,
        PreviewTemplateMessagingTemplatesPreviewPostParameters,
        TVariables,
        OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
        TContext
      >
    ): UseMutationResult<
      PreviewTemplateMessagingTemplatesPreviewPostData,
      OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Preview Template
     * @description Preview a template with given variables.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.previewTemplateMessagingTemplatesPreviewPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.previewTemplateMessagingTemplatesPreviewPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        PreviewTemplateMessagingTemplatesPreviewPostBody,
        PreviewTemplateMessagingTemplatesPreviewPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        PreviewTemplateMessagingTemplatesPreviewPostSchema,
        PreviewTemplateMessagingTemplatesPreviewPostData,
        PreviewTemplateMessagingTemplatesPreviewPostParameters,
        TVariables,
        OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
        TContext
      >
    ): UseMutationResult<
      PreviewTemplateMessagingTemplatesPreviewPostData,
      OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Preview Template
     * @description Preview a template with given variables.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const previewTemplateMessagingTemplatesPreviewPostTotal = qraft.messagingService.previewTemplateMessagingTemplatesPreviewPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const previewTemplateMessagingTemplatesPreviewPostTotal = qraft.messagingService.previewTemplateMessagingTemplatesPreviewPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            PreviewTemplateMessagingTemplatesPreviewPostBody,
            PreviewTemplateMessagingTemplatesPreviewPostData,
            PreviewTemplateMessagingTemplatesPreviewPostParameters,
            OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PreviewTemplateMessagingTemplatesPreviewPostSchema,
            PreviewTemplateMessagingTemplatesPreviewPostBody,
            PreviewTemplateMessagingTemplatesPreviewPostData,
            PreviewTemplateMessagingTemplatesPreviewPostParameters,
            OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Preview Template
     * @description Preview a template with given variables.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const previewTemplateMessagingTemplatesPreviewPostPendingMutationVariables = qraft.messagingService.previewTemplateMessagingTemplatesPreviewPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const previewTemplateMessagingTemplatesPreviewPostMutationData = qraft.messagingService.previewTemplateMessagingTemplatesPreviewPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        PreviewTemplateMessagingTemplatesPreviewPostData,
        OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
        MutationVariables<
          PreviewTemplateMessagingTemplatesPreviewPostBody,
          PreviewTemplateMessagingTemplatesPreviewPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            PreviewTemplateMessagingTemplatesPreviewPostBody,
            PreviewTemplateMessagingTemplatesPreviewPostData,
            PreviewTemplateMessagingTemplatesPreviewPostParameters,
            OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PreviewTemplateMessagingTemplatesPreviewPostSchema,
            PreviewTemplateMessagingTemplatesPreviewPostBody,
            PreviewTemplateMessagingTemplatesPreviewPostData,
            PreviewTemplateMessagingTemplatesPreviewPostParameters,
            OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          PreviewTemplateMessagingTemplatesPreviewPostData,
          OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
          MutationVariables<
            PreviewTemplateMessagingTemplatesPreviewPostBody,
            PreviewTemplateMessagingTemplatesPreviewPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Preview Template
     * @description Preview a template with given variables.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            PreviewTemplateMessagingTemplatesPreviewPostBody,
            PreviewTemplateMessagingTemplatesPreviewPostData,
            PreviewTemplateMessagingTemplatesPreviewPostParameters,
            OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PreviewTemplateMessagingTemplatesPreviewPostSchema,
            PreviewTemplateMessagingTemplatesPreviewPostBody,
            PreviewTemplateMessagingTemplatesPreviewPostData,
            PreviewTemplateMessagingTemplatesPreviewPostParameters,
            OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Preview Template
     * @description Preview a template with given variables.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.messagingService.previewTemplateMessagingTemplatesPreviewPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.messagingService.previewTemplateMessagingTemplatesPreviewPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              PreviewTemplateMessagingTemplatesPreviewPostBody,
              PreviewTemplateMessagingTemplatesPreviewPostData,
              PreviewTemplateMessagingTemplatesPreviewPostParameters,
              OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              PreviewTemplateMessagingTemplatesPreviewPostSchema,
              PreviewTemplateMessagingTemplatesPreviewPostBody,
              PreviewTemplateMessagingTemplatesPreviewPostData,
              PreviewTemplateMessagingTemplatesPreviewPostParameters,
              OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
              TContext
            >
      ):
        | Mutation<
            PreviewTemplateMessagingTemplatesPreviewPostData,
            PreviewTemplateMessagingTemplatesPreviewPostError,
            MutationVariables<
              PreviewTemplateMessagingTemplatesPreviewPostBody,
              PreviewTemplateMessagingTemplatesPreviewPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              PreviewTemplateMessagingTemplatesPreviewPostBody,
              PreviewTemplateMessagingTemplatesPreviewPostData,
              PreviewTemplateMessagingTemplatesPreviewPostParameters,
              OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              PreviewTemplateMessagingTemplatesPreviewPostSchema,
              PreviewTemplateMessagingTemplatesPreviewPostBody,
              PreviewTemplateMessagingTemplatesPreviewPostData,
              PreviewTemplateMessagingTemplatesPreviewPostParameters,
              OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
              TContext
            >
      ): Array<
        Mutation<
          PreviewTemplateMessagingTemplatesPreviewPostData,
          PreviewTemplateMessagingTemplatesPreviewPostError,
          MutationVariables<
            PreviewTemplateMessagingTemplatesPreviewPostBody,
            PreviewTemplateMessagingTemplatesPreviewPostParameters
          >,
          TContext
        >
      >;
    };
    schema: PreviewTemplateMessagingTemplatesPreviewPostSchema;
    types: {
      parameters: PreviewTemplateMessagingTemplatesPreviewPostParameters;
      data: PreviewTemplateMessagingTemplatesPreviewPostData;
      error: PreviewTemplateMessagingTemplatesPreviewPostError;
      body: PreviewTemplateMessagingTemplatesPreviewPostBody;
    };
  };
  /**
   * @summary Send Message
   * @description Send a message in a conversation.
   */
  sendMessageMessagingConversationIdMessagesPost: {
    /**
     * @summary Send Message
     * @description Send a message in a conversation.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        SendMessageMessagingConversationIdMessagesPostBody,
        SendMessageMessagingConversationIdMessagesPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: SendMessageMessagingConversationIdMessagesPostSchema,
        options: ServiceOperationMutationFnOptions<
          SendMessageMessagingConversationIdMessagesPostBody,
          SendMessageMessagingConversationIdMessagesPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          SendMessageMessagingConversationIdMessagesPostData,
          SendMessageMessagingConversationIdMessagesPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        SendMessageMessagingConversationIdMessagesPostData,
        SendMessageMessagingConversationIdMessagesPostError
      >
    >;
    /**
     * @summary Send Message
     * @description Send a message in a conversation.
     */
    getMutationKey(
      parameters: DeepReadonly<SendMessageMessagingConversationIdMessagesPostParameters> | void
    ): ServiceOperationMutationKey<
      SendMessageMessagingConversationIdMessagesPostSchema,
      SendMessageMessagingConversationIdMessagesPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Send Message
     * @description Send a message in a conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.sendMessageMessagingConversationIdMessagesPost.useMutation({
     *     path: {
     *         conversation_id: conversationId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.sendMessageMessagingConversationIdMessagesPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         conversation_id: conversationId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends SendMessageMessagingConversationIdMessagesPostBody, TContext = unknown>(
      parameters: DeepReadonly<SendMessageMessagingConversationIdMessagesPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        SendMessageMessagingConversationIdMessagesPostSchema,
        SendMessageMessagingConversationIdMessagesPostData,
        SendMessageMessagingConversationIdMessagesPostParameters,
        TVariables,
        OperationError<SendMessageMessagingConversationIdMessagesPostError>,
        TContext
      >
    ): UseMutationResult<
      SendMessageMessagingConversationIdMessagesPostData,
      OperationError<SendMessageMessagingConversationIdMessagesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Send Message
     * @description Send a message in a conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.sendMessageMessagingConversationIdMessagesPost.useMutation({
     *     path: {
     *         conversation_id: conversationId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.sendMessageMessagingConversationIdMessagesPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         conversation_id: conversationId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        SendMessageMessagingConversationIdMessagesPostBody,
        SendMessageMessagingConversationIdMessagesPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SendMessageMessagingConversationIdMessagesPostSchema,
        SendMessageMessagingConversationIdMessagesPostData,
        SendMessageMessagingConversationIdMessagesPostParameters,
        TVariables,
        OperationError<SendMessageMessagingConversationIdMessagesPostError>,
        TContext
      >
    ): UseMutationResult<
      SendMessageMessagingConversationIdMessagesPostData,
      OperationError<SendMessageMessagingConversationIdMessagesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Send Message
     * @description Send a message in a conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const sendMessageMessagingConversationIdMessagesPostTotal = qraft.messagingService.sendMessageMessagingConversationIdMessagesPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const sendMessageMessagingConversationIdMessagesPostTotal = qraft.messagingService.sendMessageMessagingConversationIdMessagesPost.useIsMutating({
     *     parameters: {
     *         path: {
     *             conversation_id: conversationId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SendMessageMessagingConversationIdMessagesPostBody,
            SendMessageMessagingConversationIdMessagesPostData,
            SendMessageMessagingConversationIdMessagesPostParameters,
            OperationError<SendMessageMessagingConversationIdMessagesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SendMessageMessagingConversationIdMessagesPostSchema,
            SendMessageMessagingConversationIdMessagesPostBody,
            SendMessageMessagingConversationIdMessagesPostData,
            SendMessageMessagingConversationIdMessagesPostParameters,
            OperationError<SendMessageMessagingConversationIdMessagesPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Send Message
     * @description Send a message in a conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const sendMessageMessagingConversationIdMessagesPostPendingMutationVariables = qraft.messagingService.sendMessageMessagingConversationIdMessagesPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const sendMessageMessagingConversationIdMessagesPostMutationData = qraft.messagingService.sendMessageMessagingConversationIdMessagesPost.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 conversation_id: conversationId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SendMessageMessagingConversationIdMessagesPostData,
        OperationError<SendMessageMessagingConversationIdMessagesPostError>,
        MutationVariables<
          SendMessageMessagingConversationIdMessagesPostBody,
          SendMessageMessagingConversationIdMessagesPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SendMessageMessagingConversationIdMessagesPostBody,
            SendMessageMessagingConversationIdMessagesPostData,
            SendMessageMessagingConversationIdMessagesPostParameters,
            OperationError<SendMessageMessagingConversationIdMessagesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SendMessageMessagingConversationIdMessagesPostSchema,
            SendMessageMessagingConversationIdMessagesPostBody,
            SendMessageMessagingConversationIdMessagesPostData,
            SendMessageMessagingConversationIdMessagesPostParameters,
            OperationError<SendMessageMessagingConversationIdMessagesPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SendMessageMessagingConversationIdMessagesPostData,
          OperationError<SendMessageMessagingConversationIdMessagesPostError>,
          MutationVariables<
            SendMessageMessagingConversationIdMessagesPostBody,
            SendMessageMessagingConversationIdMessagesPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Send Message
     * @description Send a message in a conversation.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SendMessageMessagingConversationIdMessagesPostBody,
            SendMessageMessagingConversationIdMessagesPostData,
            SendMessageMessagingConversationIdMessagesPostParameters,
            OperationError<SendMessageMessagingConversationIdMessagesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SendMessageMessagingConversationIdMessagesPostSchema,
            SendMessageMessagingConversationIdMessagesPostBody,
            SendMessageMessagingConversationIdMessagesPostData,
            SendMessageMessagingConversationIdMessagesPostParameters,
            OperationError<SendMessageMessagingConversationIdMessagesPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Send Message
     * @description Send a message in a conversation.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.messagingService.sendMessageMessagingConversationIdMessagesPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             conversation_id: conversationId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.messagingService.sendMessageMessagingConversationIdMessagesPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SendMessageMessagingConversationIdMessagesPostBody,
              SendMessageMessagingConversationIdMessagesPostData,
              SendMessageMessagingConversationIdMessagesPostParameters,
              OperationError<SendMessageMessagingConversationIdMessagesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SendMessageMessagingConversationIdMessagesPostSchema,
              SendMessageMessagingConversationIdMessagesPostBody,
              SendMessageMessagingConversationIdMessagesPostData,
              SendMessageMessagingConversationIdMessagesPostParameters,
              OperationError<SendMessageMessagingConversationIdMessagesPostError>,
              TContext
            >
      ):
        | Mutation<
            SendMessageMessagingConversationIdMessagesPostData,
            SendMessageMessagingConversationIdMessagesPostError,
            MutationVariables<
              SendMessageMessagingConversationIdMessagesPostBody,
              SendMessageMessagingConversationIdMessagesPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SendMessageMessagingConversationIdMessagesPostBody,
              SendMessageMessagingConversationIdMessagesPostData,
              SendMessageMessagingConversationIdMessagesPostParameters,
              OperationError<SendMessageMessagingConversationIdMessagesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SendMessageMessagingConversationIdMessagesPostSchema,
              SendMessageMessagingConversationIdMessagesPostBody,
              SendMessageMessagingConversationIdMessagesPostData,
              SendMessageMessagingConversationIdMessagesPostParameters,
              OperationError<SendMessageMessagingConversationIdMessagesPostError>,
              TContext
            >
      ): Array<
        Mutation<
          SendMessageMessagingConversationIdMessagesPostData,
          SendMessageMessagingConversationIdMessagesPostError,
          MutationVariables<
            SendMessageMessagingConversationIdMessagesPostBody,
            SendMessageMessagingConversationIdMessagesPostParameters
          >,
          TContext
        >
      >;
    };
    schema: SendMessageMessagingConversationIdMessagesPostSchema;
    types: {
      parameters: SendMessageMessagingConversationIdMessagesPostParameters;
      data: SendMessageMessagingConversationIdMessagesPostData;
      error: SendMessageMessagingConversationIdMessagesPostError;
      body: SendMessageMessagingConversationIdMessagesPostBody;
    };
  };
  /**
   * @summary Handle Surge Webhook
   * @description Handle message status updates from Surge.
   *
   * Surge sends webhooks for various message events:
   * - message.sent: Message was sent successfully
   * - message.delivered: Message was delivered to recipient
   * - message.failed: Message failed to send
   * - message.received: Inbound message received
   */
  handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost: {
    /**
     * @summary Handle Surge Webhook
     * @description Handle message status updates from Surge.
     *
     * Surge sends webhooks for various message events:
     * - message.sent: Message was sent successfully
     * - message.delivered: Message was delivered to recipient
     * - message.failed: Message failed to send
     * - message.received: Inbound message received
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema,
        options: ServiceOperationMutationFnOptions<
          HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
          HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
          HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError
      >
    >;
    /**
     * @summary Handle Surge Webhook
     * @description Handle message status updates from Surge.
     *
     * Surge sends webhooks for various message events:
     * - message.sent: Message was sent successfully
     * - message.delivered: Message was delivered to recipient
     * - message.failed: Message failed to send
     * - message.received: Inbound message received
     */
    getMutationKey(
      parameters: DeepReadonly<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters> | void
    ): ServiceOperationMutationKey<
      HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema,
      HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Handle Surge Webhook
     * @description Handle message status updates from Surge.
     *
     * Surge sends webhooks for various message events:
     * - message.sent: Message was sent successfully
     * - message.delivered: Message was delivered to recipient
     * - message.failed: Message failed to send
     * - message.received: Inbound message received
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody, TContext = unknown>(
      parameters: DeepReadonly<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema,
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
        TVariables,
        OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
        TContext
      >
    ): UseMutationResult<
      HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
      OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Handle Surge Webhook
     * @description Handle message status updates from Surge.
     *
     * Surge sends webhooks for various message events:
     * - message.sent: Message was sent successfully
     * - message.delivered: Message was delivered to recipient
     * - message.failed: Message failed to send
     * - message.received: Inbound message received
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema,
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
        TVariables,
        OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
        TContext
      >
    ): UseMutationResult<
      HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
      OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Handle Surge Webhook
     * @description Handle message status updates from Surge.
     *
     * Surge sends webhooks for various message events:
     * - message.sent: Message was sent successfully
     * - message.delivered: Message was delivered to recipient
     * - message.failed: Message failed to send
     * - message.received: Inbound message received
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostTotal = qraft.messagingService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostTotal = qraft.messagingService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
            OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
            OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Handle Surge Webhook
     * @description Handle message status updates from Surge.
     *
     * Surge sends webhooks for various message events:
     * - message.sent: Message was sent successfully
     * - message.delivered: Message was delivered to recipient
     * - message.failed: Message failed to send
     * - message.received: Inbound message received
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostPendingMutationVariables = qraft.messagingService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostMutationData = qraft.messagingService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
        OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
        MutationVariables<
          HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
          HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
            OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
            OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
          OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
          MutationVariables<
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Handle Surge Webhook
     * @description Handle message status updates from Surge.
     *
     * Surge sends webhooks for various message events:
     * - message.sent: Message was sent successfully
     * - message.delivered: Message was delivered to recipient
     * - message.failed: Message failed to send
     * - message.received: Inbound message received
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
            OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
            OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Handle Surge Webhook
     * @description Handle message status updates from Surge.
     *
     * Surge sends webhooks for various message events:
     * - message.sent: Message was sent successfully
     * - message.delivered: Message was delivered to recipient
     * - message.failed: Message failed to send
     * - message.received: Inbound message received
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.messagingService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.messagingService.handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
              OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
              OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
              TContext
            >
      ):
        | Mutation<
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError,
            MutationVariables<
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
              OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
              HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters,
              OperationError<HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError>,
              TContext
            >
      ): Array<
        Mutation<
          HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData,
          HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError,
          MutationVariables<
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody,
            HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters
          >,
          TContext
        >
      >;
    };
    schema: HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema;
    types: {
      parameters: HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters;
      data: HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData;
      error: HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError;
      body: HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody;
    };
  };
  /**
   * @summary Handle Surge Conversation Webhook
   * @description Handle conversation updates from Surge.
   *
   * This can include:
   * - New conversations created
   * - Conversation status changes
   * - Contact information updates
   */
  handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost: {
    /**
     * @summary Handle Surge Conversation Webhook
     * @description Handle conversation updates from Surge.
     *
     * This can include:
     * - New conversations created
     * - Conversation status changes
     * - Contact information updates
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema,
        options: ServiceOperationMutationFnOptions<
          HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
          HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
          HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError
      >
    >;
    /**
     * @summary Handle Surge Conversation Webhook
     * @description Handle conversation updates from Surge.
     *
     * This can include:
     * - New conversations created
     * - Conversation status changes
     * - Contact information updates
     */
    getMutationKey(
      parameters: DeepReadonly<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters> | void
    ): ServiceOperationMutationKey<
      HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema,
      HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Handle Surge Conversation Webhook
     * @description Handle conversation updates from Surge.
     *
     * This can include:
     * - New conversations created
     * - Conversation status changes
     * - Contact information updates
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema,
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
        TVariables,
        OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
        TContext
      >
    ): UseMutationResult<
      HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
      OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Handle Surge Conversation Webhook
     * @description Handle conversation updates from Surge.
     *
     * This can include:
     * - New conversations created
     * - Conversation status changes
     * - Contact information updates
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.messagingService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema,
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
        TVariables,
        OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
        TContext
      >
    ): UseMutationResult<
      HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
      OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Handle Surge Conversation Webhook
     * @description Handle conversation updates from Surge.
     *
     * This can include:
     * - New conversations created
     * - Conversation status changes
     * - Contact information updates
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostTotal = qraft.messagingService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostTotal = qraft.messagingService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
            OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
            OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Handle Surge Conversation Webhook
     * @description Handle conversation updates from Surge.
     *
     * This can include:
     * - New conversations created
     * - Conversation status changes
     * - Contact information updates
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostPendingMutationVariables = qraft.messagingService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostMutationData = qraft.messagingService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
        OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
        MutationVariables<
          HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
          HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
            OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
            OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
          OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
          MutationVariables<
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Handle Surge Conversation Webhook
     * @description Handle conversation updates from Surge.
     *
     * This can include:
     * - New conversations created
     * - Conversation status changes
     * - Contact information updates
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
            OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
            OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Handle Surge Conversation Webhook
     * @description Handle conversation updates from Surge.
     *
     * This can include:
     * - New conversations created
     * - Conversation status changes
     * - Contact information updates
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.messagingService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.messagingService.handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
              OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
              OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
              TContext
            >
      ):
        | Mutation<
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError,
            MutationVariables<
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
              OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
              HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters,
              OperationError<HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError>,
              TContext
            >
      ): Array<
        Mutation<
          HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData,
          HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError,
          MutationVariables<
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody,
            HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters
          >,
          TContext
        >
      >;
    };
    schema: HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema;
    types: {
      parameters: HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters;
      data: HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData;
      error: HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError;
      body: HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody;
    };
  };
}
/**
 * @summary Create Conversation
 * @description Create a new conversation.
 */
export const createConversationMessagingConversationsPost = {
  schema: {
    method: 'post',
    url: '/messaging/conversations/',
    mediaType: ['application/json'],
  },
} as {
  schema: CreateConversationMessagingConversationsPostSchema;
  [QraftServiceOperationsToken]: MessagingService['createConversationMessagingConversationsPost'];
};
/**
 * @summary List Conversations
 * @description List conversations with optional filters.
 */
export const listConversationsMessagingConversationsGet = {
  schema: {
    method: 'get',
    url: '/messaging/conversations/',
  },
} as {
  schema: ListConversationsMessagingConversationsGetSchema;
  [QraftServiceOperationsToken]: MessagingService['listConversationsMessagingConversationsGet'];
};
/**
 * @summary Get Conversation
 * @description Get a conversation with all its messages.
 */
export const getConversationMessagingConversationsConversationIdGet = {
  schema: {
    method: 'get',
    url: '/messaging/conversations/{conversation_id}',
  },
} as {
  schema: GetConversationMessagingConversationsConversationIdGetSchema;
  [QraftServiceOperationsToken]: MessagingService['getConversationMessagingConversationsConversationIdGet'];
};
/**
 * @summary List Templates
 * @description List message templates with optional filters.
 */
export const listTemplatesMessagingTemplatesGet = {
  schema: {
    method: 'get',
    url: '/messaging/templates/',
  },
} as {
  schema: ListTemplatesMessagingTemplatesGetSchema;
  [QraftServiceOperationsToken]: MessagingService['listTemplatesMessagingTemplatesGet'];
};
/**
 * @summary Create Template
 * @description Create a new message template.
 */
export const createTemplateMessagingTemplatesPost = {
  schema: {
    method: 'post',
    url: '/messaging/templates/',
    mediaType: ['application/json'],
  },
} as {
  schema: CreateTemplateMessagingTemplatesPostSchema;
  [QraftServiceOperationsToken]: MessagingService['createTemplateMessagingTemplatesPost'];
};
/**
 * @summary Get Template
 * @description Get a message template by ID.
 */
export const getTemplateMessagingTemplatesTemplateIdGet = {
  schema: {
    method: 'get',
    url: '/messaging/templates/{template_id}',
  },
} as {
  schema: GetTemplateMessagingTemplatesTemplateIdGetSchema;
  [QraftServiceOperationsToken]: MessagingService['getTemplateMessagingTemplatesTemplateIdGet'];
};
/**
 * @summary Update Template
 * @description Update a message template.
 */
export const updateTemplateMessagingTemplatesTemplateIdPut = {
  schema: {
    method: 'put',
    url: '/messaging/templates/{template_id}',
    mediaType: ['application/json'],
  },
} as {
  schema: UpdateTemplateMessagingTemplatesTemplateIdPutSchema;
  [QraftServiceOperationsToken]: MessagingService['updateTemplateMessagingTemplatesTemplateIdPut'];
};
/**
 * @summary Delete Template
 * @description Delete a message template.
 */
export const deleteTemplateMessagingTemplatesTemplateIdDelete = {
  schema: {
    method: 'delete',
    url: '/messaging/templates/{template_id}',
  },
} as {
  schema: DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema;
  [QraftServiceOperationsToken]: MessagingService['deleteTemplateMessagingTemplatesTemplateIdDelete'];
};
/**
 * @summary Preview Template
 * @description Preview a template with given variables.
 */
export const previewTemplateMessagingTemplatesPreviewPost = {
  schema: {
    method: 'post',
    url: '/messaging/templates/preview',
    mediaType: ['application/json'],
  },
} as {
  schema: PreviewTemplateMessagingTemplatesPreviewPostSchema;
  [QraftServiceOperationsToken]: MessagingService['previewTemplateMessagingTemplatesPreviewPost'];
};
/**
 * @summary Send Message
 * @description Send a message in a conversation.
 */
export const sendMessageMessagingConversationIdMessagesPost = {
  schema: {
    method: 'post',
    url: '/messaging/{conversation_id}/messages',
    mediaType: ['application/json'],
  },
} as {
  schema: SendMessageMessagingConversationIdMessagesPostSchema;
  [QraftServiceOperationsToken]: MessagingService['sendMessageMessagingConversationIdMessagesPost'];
};
/**
 * @summary Handle Surge Webhook
 * @description Handle message status updates from Surge.
 *
 * Surge sends webhooks for various message events:
 * - message.sent: Message was sent successfully
 * - message.delivered: Message was delivered to recipient
 * - message.failed: Message failed to send
 * - message.received: Inbound message received
 */
export const handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost = {
  schema: {
    method: 'post',
    url: '/messaging/webhooks/surge/message-status',
    mediaType: ['application/json'],
  },
} as {
  schema: HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema;
  [QraftServiceOperationsToken]: MessagingService['handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost'];
};
/**
 * @summary Handle Surge Conversation Webhook
 * @description Handle conversation updates from Surge.
 *
 * This can include:
 * - New conversations created
 * - Conversation status changes
 * - Contact information updates
 */
export const handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost = {
  schema: {
    method: 'post',
    url: '/messaging/webhooks/surge/conversation-update',
    mediaType: ['application/json'],
  },
} as {
  schema: HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema;
  [QraftServiceOperationsToken]: MessagingService['handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost'];
};
export const messagingService = {
  createConversationMessagingConversationsPost,
  listConversationsMessagingConversationsGet,
  getConversationMessagingConversationsConversationIdGet,
  listTemplatesMessagingTemplatesGet,
  createTemplateMessagingTemplatesPost,
  getTemplateMessagingTemplatesTemplateIdGet,
  updateTemplateMessagingTemplatesTemplateIdPut,
  deleteTemplateMessagingTemplatesTemplateIdDelete,
  previewTemplateMessagingTemplatesPreviewPost,
  sendMessageMessagingConversationIdMessagesPost,
  handleSurgeWebhookMessagingWebhooksSurgeMessageStatusPost,
  handleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePost,
} as const;
type CreateConversationMessagingConversationsPostSchema = {
  method: 'post';
  url: '/messaging/conversations/';
  mediaType: ['application/json'];
};
type CreateConversationMessagingConversationsPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateConversationMessagingConversationsPostData =
  paths['/messaging/conversations/']['post']['responses']['200']['content']['application/json'];
type CreateConversationMessagingConversationsPostError =
  paths['/messaging/conversations/']['post']['responses']['422']['content']['application/json'];
type CreateConversationMessagingConversationsPostBody =
  paths['/messaging/conversations/']['post']['requestBody']['content']['application/json'];
type ListConversationsMessagingConversationsGetSchema = {
  method: 'get';
  url: '/messaging/conversations/';
};
type ListConversationsMessagingConversationsGetParameters = paths['/messaging/conversations/']['get']['parameters'];
type ListConversationsMessagingConversationsGetData =
  paths['/messaging/conversations/']['get']['responses']['200']['content']['application/json'];
type ListConversationsMessagingConversationsGetError =
  paths['/messaging/conversations/']['get']['responses']['422']['content']['application/json'];
type GetConversationMessagingConversationsConversationIdGetSchema = {
  method: 'get';
  url: '/messaging/conversations/{conversation_id}';
};
type GetConversationMessagingConversationsConversationIdGetParameters =
  paths['/messaging/conversations/{conversation_id}']['get']['parameters'];
type GetConversationMessagingConversationsConversationIdGetData =
  paths['/messaging/conversations/{conversation_id}']['get']['responses']['200']['content']['application/json'];
type GetConversationMessagingConversationsConversationIdGetError =
  paths['/messaging/conversations/{conversation_id}']['get']['responses']['422']['content']['application/json'];
type ListTemplatesMessagingTemplatesGetSchema = {
  method: 'get';
  url: '/messaging/templates/';
};
type ListTemplatesMessagingTemplatesGetParameters = paths['/messaging/templates/']['get']['parameters'];
type ListTemplatesMessagingTemplatesGetData =
  paths['/messaging/templates/']['get']['responses']['200']['content']['application/json'];
type ListTemplatesMessagingTemplatesGetError =
  paths['/messaging/templates/']['get']['responses']['422']['content']['application/json'];
type CreateTemplateMessagingTemplatesPostSchema = {
  method: 'post';
  url: '/messaging/templates/';
  mediaType: ['application/json'];
};
type CreateTemplateMessagingTemplatesPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateTemplateMessagingTemplatesPostData =
  paths['/messaging/templates/']['post']['responses']['200']['content']['application/json'];
type CreateTemplateMessagingTemplatesPostError =
  paths['/messaging/templates/']['post']['responses']['422']['content']['application/json'];
type CreateTemplateMessagingTemplatesPostBody =
  paths['/messaging/templates/']['post']['requestBody']['content']['application/json'];
type GetTemplateMessagingTemplatesTemplateIdGetSchema = {
  method: 'get';
  url: '/messaging/templates/{template_id}';
};
type GetTemplateMessagingTemplatesTemplateIdGetParameters =
  paths['/messaging/templates/{template_id}']['get']['parameters'];
type GetTemplateMessagingTemplatesTemplateIdGetData =
  paths['/messaging/templates/{template_id}']['get']['responses']['200']['content']['application/json'];
type GetTemplateMessagingTemplatesTemplateIdGetError =
  paths['/messaging/templates/{template_id}']['get']['responses']['422']['content']['application/json'];
type UpdateTemplateMessagingTemplatesTemplateIdPutSchema = {
  method: 'put';
  url: '/messaging/templates/{template_id}';
  mediaType: ['application/json'];
};
type UpdateTemplateMessagingTemplatesTemplateIdPutParameters =
  paths['/messaging/templates/{template_id}']['put']['parameters'];
type UpdateTemplateMessagingTemplatesTemplateIdPutData =
  paths['/messaging/templates/{template_id}']['put']['responses']['200']['content']['application/json'];
type UpdateTemplateMessagingTemplatesTemplateIdPutError =
  paths['/messaging/templates/{template_id}']['put']['responses']['422']['content']['application/json'];
type UpdateTemplateMessagingTemplatesTemplateIdPutBody =
  paths['/messaging/templates/{template_id}']['put']['requestBody']['content']['application/json'];
type DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema = {
  method: 'delete';
  url: '/messaging/templates/{template_id}';
};
type DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters =
  paths['/messaging/templates/{template_id}']['delete']['parameters'];
type DeleteTemplateMessagingTemplatesTemplateIdDeleteData = null;
type DeleteTemplateMessagingTemplatesTemplateIdDeleteError =
  paths['/messaging/templates/{template_id}']['delete']['responses']['422']['content']['application/json'];
type DeleteTemplateMessagingTemplatesTemplateIdDeleteBody = undefined;
type PreviewTemplateMessagingTemplatesPreviewPostSchema = {
  method: 'post';
  url: '/messaging/templates/preview';
  mediaType: ['application/json'];
};
type PreviewTemplateMessagingTemplatesPreviewPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type PreviewTemplateMessagingTemplatesPreviewPostData =
  paths['/messaging/templates/preview']['post']['responses']['200']['content']['application/json'];
type PreviewTemplateMessagingTemplatesPreviewPostError =
  paths['/messaging/templates/preview']['post']['responses']['422']['content']['application/json'];
type PreviewTemplateMessagingTemplatesPreviewPostBody =
  paths['/messaging/templates/preview']['post']['requestBody']['content']['application/json'];
type SendMessageMessagingConversationIdMessagesPostSchema = {
  method: 'post';
  url: '/messaging/{conversation_id}/messages';
  mediaType: ['application/json'];
};
type SendMessageMessagingConversationIdMessagesPostParameters =
  paths['/messaging/{conversation_id}/messages']['post']['parameters'];
type SendMessageMessagingConversationIdMessagesPostData =
  paths['/messaging/{conversation_id}/messages']['post']['responses']['200']['content']['application/json'];
type SendMessageMessagingConversationIdMessagesPostError =
  paths['/messaging/{conversation_id}/messages']['post']['responses']['422']['content']['application/json'];
type SendMessageMessagingConversationIdMessagesPostBody =
  paths['/messaging/{conversation_id}/messages']['post']['requestBody']['content']['application/json'];
type HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostSchema = {
  method: 'post';
  url: '/messaging/webhooks/surge/message-status';
  mediaType: ['application/json'];
};
type HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostData =
  paths['/messaging/webhooks/surge/message-status']['post']['responses']['200']['content']['application/json'];
type HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostError =
  paths['/messaging/webhooks/surge/message-status']['post']['responses']['422']['content']['application/json'];
type HandleSurgeWebhookMessagingWebhooksSurgeMessageStatusPostBody =
  paths['/messaging/webhooks/surge/message-status']['post']['requestBody']['content']['application/json'];
type HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostSchema = {
  method: 'post';
  url: '/messaging/webhooks/surge/conversation-update';
  mediaType: ['application/json'];
};
type HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostData =
  paths['/messaging/webhooks/surge/conversation-update']['post']['responses']['200']['content']['application/json'];
type HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostError =
  paths['/messaging/webhooks/surge/conversation-update']['post']['responses']['422']['content']['application/json'];
type HandleSurgeConversationWebhookMessagingWebhooksSurgeConversationUpdatePostBody =
  paths['/messaging/webhooks/surge/conversation-update']['post']['requestBody']['content']['application/json'];
